import $ from '@alife/alpha-jquery/jquery';

const log = (...args) => {
  if (location.search.indexOf('debug') < 0) {
    return;
  }
  // eslint-disable-next-line
  console.log(...args);
};

const hasEle = selector => !!$(selector).get(0);

export {
  log,
  hasEle,
};

